
function reloadStylesheets() {
    var queryString = '?reload=' + new Date().getTime();
    $('link[rel="stylesheet"]').each(function () {
        this.href = this.href.replace(/\?.*|$/, queryString);
    });
}

$(function() {

    if( $('#dev-reload-css-link').length==0 ){
        $('body').prepend('<a href="#" id="dev-reload-css-link">Reload CSS</a>');
    }

    $('body').on('click', '#dev-reload-css-link', reloadStylesheets);

});